import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortalModule } from '@angular/cdk/portal';
import { ObserversModule } from '@angular/cdk/observers';

import { EuiTabComponent } from './eui-tab/eui-tab.component';
import { EuiTabsComponent, EuiTabsRightContentTagDirective } from './eui-tabs.component';
import { EuiIconModule } from '../atoms';
import { EuiTabLabelComponent } from './eui-tab-label/eui-tab-label.component';
import { EuiTabContentComponent } from './eui-tab-content/eui-tab-content.component';
import { EuiButtonModule } from '../eui-button';
import { EuiTooltipDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        PortalModule,
        EuiIconModule,
        EuiButtonModule,
        EuiTooltipDirectiveModule,
        ObserversModule,
    ],
    exports: [
        EuiTabsComponent,
        EuiTabComponent,
        EuiTabsRightContentTagDirective,
        EuiTabLabelComponent,
        EuiTabContentComponent,
    ],
    declarations: [
        EuiTabsComponent,
        EuiTabComponent,
        EuiTabsRightContentTagDirective,
        EuiTabLabelComponent,
        EuiTabContentComponent,
    ],
})
export class EuiTabsModule {}
